var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 1C10.31 1 5.68 5.63 5.68 11.321v7.158a3.844 3.844 0 0 0-3.07 3.76 3.841 3.841 0 0 0 3.838 3.836h4.021C10.791 28.843 13.147 31 16 31s5.209-2.157 5.53-4.925h4.022a3.841 3.841 0 0 0 3.837-3.837 3.844 3.844 0 0 0-3.068-3.76v-7.157C26.32 5.63 21.69 1 16 1zm0 27.097a2.674 2.674 0 0 1-2.589-2.022h5.178A2.674 2.674 0 0 1 16 28.097zm10.486-5.859c0 .515-.42.934-.934.934H6.448a.935.935 0 0 1 0-1.867h.683c.802 0 1.452-.65 1.452-1.452v-8.532c0-4.09 3.327-7.418 7.417-7.418s7.417 3.328 7.417 7.418v8.532c0 .801.65 1.452 1.452 1.452h.683c.515 0 .934.418.934.933z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.4dd1ebf3d9b699d4aee9db8f4a8b58aa.svg";
export { ForwardRef as ReactComponent };